import { StationPageWrapper } from '@app/core/routing/StationPageWrapper';
import { FragmentsViewPage } from '../screens/view/FragmentsViewPage';

export function FragmentsViewStationPage() {
  return (
    <StationPageWrapper>
      <FragmentsViewPage />
    </StationPageWrapper>
  );
}
